import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
const Utilities = {




  uuidString: () => (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1),
};

export default Utilities;
